import { useField } from "formik";
import { FC } from "react";
import Select, { Props } from "react-select";

interface FormikSelectOption {
    value: string;
    label: string;
}
interface FormikSelectProps extends Props {
    options: any[];
    // options: FormikSelectOption[] | FormikSelectOptionExtended[];
}

// interface FormikSelectOptionExtended extends FormikSelectOption {
//     // Add any additional properties or methods here
// }

const FormikSelect: FC<FormikSelectProps> = ({ options, className, ...props }) => {
    const [field, , helpers] = useField(props as any);

    const getFieldValue = () => {
        if (Array.isArray(field.value)) {
            return field.value.map((item) =>
                options?.find((option) => option.value === item.value)
            );
        } else if (typeof field.value === "object") {
            return options?.find((option) => option.value === field.value["value"]);
        } else {
            return null;
        }
    };

    const getOptionById = (selectedOption: FormikSelectOption | FormikSelectOption[]) => {
        if (Array.isArray(selectedOption)) {
            return options.filter((option) =>
                selectedOption.map((item) => item.value).includes(option.value)
            );
        } else {
            return options?.find(
                (option) => option.value === (selectedOption as FormikSelectOption).value
            );
        }
    };

    return (
        <Select
            className={`react-select-container ${className}`}
            classNamePrefix="react-select"
            options={options}
            name={field.name}
            value={getFieldValue()}
            onChange={(option) => helpers.setValue(getOptionById(option as any))}
            onBlur={() => helpers.setTouched(true)}
            {...props}
        />
    );
};

export default FormikSelect;
